<template>
    <modal
      :show="showUpModal"
      :close="closeUpModal"
      :title="titleUpModal"
      class-name="modal-xl"
    >
      <loading-container :loading="loadingData">
        <form v-if="!multipleRow">
          <input-text
            :value="designForm.title"
            name="designTitle"
            placeholder="Input title"
            label="Title"
            :required="true"
            type="text"
            :errors="designFormError.title"
            @input="value => setDesignFormField({ key: 'title', value })"
          />
          <color-picker
            :values="designForm.colors"
            :options="colorOptions"
            name="designColors"
            :required="true"
            label="Colors"
            :errors="designFormError.colors"
            @input="value => setDesignFormField({ key: 'colors', value })"
          />
          <text-area
            :value="designForm.description"
            name="designDescription"
            placeholder="Description"
            label="Description"
            :errors="designFormError.description"
            @input="value => setDesignFormField({ key: 'description', value })"
          />
          <div>
            <label>Prices ($)<span class="text-danger">*</span></label>
            <div v-for="item in sizeOptions" :key="item.value">
              <input-text
                :placeholder="item.text"
                :name="`designPrices.${item.value}`"
                :value="designForm.prices[item.value]"
                type="number"
                :inputGroup="true"
                :errors="designFormError[`prices.${item.value}`]"
                @input="value => setDesignFormField({ key: `prices.${item.value}`, value})"
              >
                <div class="input-group-prepend" slot="prefix">
                  <span class="input-group-text">{{item.text}}</span>
                </div>
              </input-text>
            </div>
          </div>
          <input-text
            :value="designForm.keywords"
            placeholder="Key1, Key2,..."
            label="Keywords"
            type="text"
            @input="value => setDesignFormField({ key: 'keywords', value })"
          />
        </form>
        <div v-else>
          <div class="w-100">
            <ul class="nav nav-tabs customtab" role="tablist">
              <li 
                class="nav-item" 
                v-for="tab in designForm"
                :key="tab.id"
              >
                <a class="nav-link cursor-pointer" data-toggle="tab" role="tab"
                   :class="{'active': tab.active}"
                   @click="selectTab(tab.id)">
                  {{catalogName(tab.catalogId, mockupOptions)}}
                </a>
              </li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content p-20">
              <div 
                class="tab-pane" 
                v-for="(opt) in designForm" 
                :class="{'active': opt.active}"
                :key="opt.catalogId"
              >
                <div>
                  <input-text
                    :value="form.information && form.information[opt.catalogId] && form.information[opt.catalogId].title ? form.information[opt.catalogId].title : ''"
                    placeholder="Input title"
                    label="Title"
                    :required="true"
                    type="text"
                    :errors="designFormError[`information.${opt.catalogId}.title`]"
                    @input="value => setDesignFormField({ key: `information.${opt.catalogId}.title`, value })"
                  />
                  <color-picker
                    :values="form.information && form.information[opt.catalogId] && form.information[opt.catalogId].colors ? form.information[opt.catalogId].colors : ''"
                    :options="typeOptionsMultiple({option: opt, type: 'colors'})"
                    :required="true"
                    label="Colors"
                    :errors="designFormError[`information.${opt.catalogId}.colors`]"
                    @input="value => setDesignFormField({ key: `information.${opt.catalogId}.colors`, value })"
                  />
                  <text-area
                    :value="form.information && form.information[opt.catalogId] && form.information[opt.catalogId].description ? form.information[opt.catalogId].description : ''"
                    placeholder="Description"
                    label="Description"
                    @input="value => setDesignFormField({ key: `information.${opt.catalogId}.description`, value })"
                  />
                  <div>
                    <label>Prices ($)<span class="text-danger">*</span></label>
                    <div 
                      v-for="item in typeOptionsMultiple({option: opt, type: 'sizes'})"
                      :key="item"
                    >
                      <input-text
                        :placeholder="item | sizeDisplay"
                        :value="form.information && form.information[opt.catalogId] && form.information[opt.catalogId].prices && form.information[opt.catalogId].prices[item]"
                        type="number"
                        :inputGroup="true"
                        :errors="designFormError[`information.${opt.catalogId}.prices.${item}`]"
                        @input="value => setDesignFormField({ key: `information.${opt.catalogId}.prices.${item}`, value})"
                      >
                        <div class="input-group-prepend" slot="prefix">
                          <span class="input-group-text">{{ item | sizeDisplay }}</span>
                        </div>
                      </input-text>
                    </div>
                  </div>
                  <input-text
                    :value="form.information && form.information[opt.catalogId] && form.information[opt.catalogId].keywords ? form.information[opt.catalogId].keywords : ''"
                    placeholder="Key1, Key2,..."
                    label="Keywords"
                    type="text"
                    @input="value => setDesignFormField({ key: `information.${opt.catalogId}.keywords`, value })"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </loading-container>
      <div slot="footer" v-if="!loadingData">
        <link-button
          class="btn btn-light waves-effect waves-light"
          :click="closeDesignForm"
        >
          Cancel
        </link-button>
        <form-button
          type="primary"
          class="btn btn-success waves-effect waves-light m-l-10"
          :loading="loading"
          :click="saveDesignForm"
          text="SAVE"
        />
      </div>
    </modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import Modal from '@/components/Misc/Modal'
import InputText from "@/components/Form/InputText"
import ColorPicker from "@/components/Form/ColorPicker"
import TextArea from "@/components/Form/TextArea"
import LinkButton from "@/components/Misc/LinkButton"
import FormButton from "@/components/Form/FormButton";
import LoadingContainer from "@/components/Misc/LoadingContainer";

export default {
  name: "UploadModal",
  components: {
    Modal,
    InputText,
    ColorPicker,
    TextArea,
    LinkButton,
    FormButton,
    LoadingContainer
  },
  computed: {
    ...mapGetters({
      mockupOptions: "upload/mockupOptions",
    }),
    colorOptions() {
      return _.get(this.editOptions, 'colors', {});
    },
    sizeOptions() {
      return _.get(this.editOptions, 'sizes', {});
    },
  },
  methods: {
    ...mapActions({
    }),
    typeOptionsMultiple(obj) {
      return _.get(obj.option.variation, obj.type, {});
    },
    catalogName(catalogId, mockupOptions) {
      const mockup = mockupOptions.find(o => o.value == catalogId);
      return mockup ? mockup.text : 'Unknown';
    },
  },
  props: {
    showUpModal: Boolean,
    loadingData: Boolean,
    multipleRow: Boolean,
    closeUpModal: Function,
    titleUpModal: String,
    designForm: Array | Object,
    form: Array | Object,
    designFormError: Object,
    editOptions: Array | Object,
    closeDesignForm: Function,
    saveDesignForm: Function,
    selectTab: Function,
    setDesignFormField: Function,
    loading: Boolean
  }
}
</script>

<style scoped>
.nav {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
